// import { NavLink } from "react-router-dom";

// const menu = [
//   { path: "orders", label: "Orders" },
//   { path: "profile", label: "Profile" },
//   { path: "addresses", label: "Addresses" },
//   { path: "security", label: "Security" },
//   { path: "settings", label: "Settings" },
//   { path: "notifications", label: "Notifications" },
//   { path: "support", label: "Support" },
//   { path: "seller-request", label: "Become a Seller" },
// ];

// export default function BuyerSidebar({ onNavigate }) {
//   const handleNavigate = () => {
//     if (onNavigate) onNavigate(); // close sidebar on mobile
//   };

//   return (
//     <aside
//       className="
//         bg-white
//         border
//         rounded-3
//         shadow-sm
//         d-flex
//         flex-column
//       "
//       style={{
//         width: "260px",

//         /* 🔹 Desktop */
//         height: "100%",

//         /* 🔹 Mobile UX */
//         maxHeight: "70vh",
//         overflow: "hidden",
//       }}
//     >
//       {/* HEADER */}
//       <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
//         <h6 className="fw-bold mb-0">Buyer Dashboard</h6>

//         {/* Mobile close button */}
//         <button
//           className="btn btn-sm btn-light d-lg-none"
//           onClick={handleNavigate}
//           aria-label="Close sidebar"
//         >
//           ✕
//         </button>
//       </div>

//       {/* MENU */}
//       <div
//         className="flex-grow-1 overflow-auto"
//         style={{ WebkitOverflowScrolling: "touch" }}
//       >
//         <ul className="list-group list-group-flush">
//           {menu.map((item) => (
//             <NavLink
//               key={item.path}
//               to={item.path}
//               onClick={handleNavigate}
//               className={({ isActive }) =>
//                 `
//                   list-group-item
//                   list-group-item-action
//                   border-0
//                   px-4
//                   py-3
//                   ${isActive ? "active fw-semibold" : ""}
//                 `
//               }
//             >
//               {item.label}
//             </NavLink>
//           ))}
//         </ul>
//       </div>
//     </aside>
//   );
// }

import { NavLink } from "react-router-dom";

const menu = [
  { path: "orders", label: "Orders" },
  { path: "profile", label: "Profile" },
  { path: "addresses", label: "Addresses" },
  { path: "security", label: "Security" },
  { path: "settings", label: "Settings" },
  { path: "notifications", label: "Notifications" },
  { path: "support", label: "Support" },
  { path: "seller-request", label: "Become a Seller" },
];

export default function BuyerSidebar({ onNavigate }) {
  return (
    <aside className="w-100">
      <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
        <h6 className="fw-bold mb-0">Buyer Dashboard</h6>

        <button className="btn btn-sm btn-light d-lg-none" onClick={onNavigate}>
          ✕
        </button>
      </div>

      <ul className="list-group list-group-flush">
        {menu.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            onClick={onNavigate}
            className={({ isActive }) =>
              `list-group-item list-group-item-action border-0 px-4 py-3 ${
                isActive ? "active fw-semibold" : ""
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </ul>
    </aside>
  );
}
